import styled from "styled-components";

// td
const Td = styled.td`
    cursor: pointer;
    border: 1px solid #aaa;
    background-clip: padding-box;
    scroll-snap-align: start;
    background-color: #f8f8f8;
    padding: 0.2rem;
    min-width: 2rem;
    margin: 0;
    text-align: center;
`

export default Td